import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const ChatGe: React.FC<SvgIconDefaultProps> = ({ className, testId }) => {
  return (
    <CustomSvg
      className={className}
      data-cy={testId}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_48697_84270)">
        <path
          d="M12.9596 21.6H11.9996C11.2057 21.6 10.5596 20.9539 10.5596 20.16C10.5596 19.3661 11.2057 18.72 11.9996 18.72H12.9596C13.7535 18.72 14.3996 19.3661 14.3996 20.16C14.3996 20.9539 13.7535 21.6 12.9596 21.6Z"
          fill="#286AF6"
        />
        <path
          d="M21.5996 11.52H20.6396V16.8H21.5996C22.6556 16.8 23.5196 15.936 23.5196 14.88V13.44C23.5196 12.384 22.6556 11.52 21.5996 11.52Z"
          fill="#286AF6"
        />
        <path
          d="M20.5912 17.76C20.5912 17.76 19.6801 17.76 19.6801 16.8C19.6801 15.84 19.6801 14.88 19.6801 14.88C19.6801 15.504 18.4801 15.648 18.4801 15.648C18.2881 15.648 18.0961 15.84 18.0481 16.0325C17.882 16.7952 17.643 17.5334 17.3396 18.2501C17.2974 18.335 17.2528 18.4296 17.2052 18.54C17.0219 18.9629 16.8217 19.3397 16.6201 19.68H18.2401C19.3988 19.68 20.3689 18.8539 20.5912 17.76Z"
          fill="#286AF6"
        />
        <path
          d="M23.5046 17.0347C22.9958 17.4845 22.3301 17.76 21.6 17.76H21.5616C21.3274 19.3857 19.9291 20.64 18.24 20.64H15.9787C15.7536 20.9371 15.551 21.1699 15.3998 21.3326C15.373 21.3614 15.3466 21.3902 15.3192 21.4185C15.1944 21.5481 15.12 21.6149 15.12 21.6149L15.1205 21.6158C14.207 22.4851 13.1386 23.04 12 23.04C9.696 23.04 7.728 20.736 5.904 15.936C5.856 15.744 5.664 15.6475 5.52 15.6475C4.848 15.6 4.32 15.024 4.32 14.304C4.32 14.016 4.368 13.6325 4.56 13.488C4.752 13.344 5.136 13.3925 5.136 13.3925C5.184 13.3925 5.232 13.3925 5.28 13.3925C9.264 13.3925 13.056 9.45645 14.4 6.91245C15.84 9.98445 18.24 12.8165 18.336 12.9605C18.432 13.0565 18.576 13.1525 18.72 13.1525C18.72 13.1525 19.403 13.1597 19.68 13.7294C19.68 13.7294 19.68 12.48 19.68 11.52C19.68 10.56 20.64 10.56 20.64 10.56H21.6C21.924 10.56 22.2341 10.6161 22.525 10.715C22.1717 5.70285 19.0334 2.11581 14.7552 1.92765L14.3779 0.720452C14.3155 0.520292 14.1302 0.383972 13.92 0.383972C4.68336 0.383972 0 7.84509 0 22.56C0 22.7011 0.0624 22.8355 0.16992 22.9267C0.25776 23.0006 0.36768 23.04 0.48 23.04C0.50688 23.04 0.53328 23.0376 0.56016 23.0333C0.588 23.0289 3.4128 22.56 8.64 22.56C8.64528 22.56 8.6496 22.5571 8.6544 22.5571C9.59136 23.4326 10.6944 24 12 24C13.3123 24 14.5118 23.4389 15.539 22.548C15.5597 22.5504 15.5784 22.56 15.6 22.56C20.7178 22.56 23.4096 23.028 23.4355 23.0323C23.4638 23.0376 23.4917 23.04 23.52 23.04C23.6314 23.04 23.7413 23.0011 23.8282 22.9281C23.9371 22.8365 24 22.7021 24 22.56C24 19.8801 23.7384 18.0955 23.5046 17.0347Z"
          fill="#286AF6"
        />
        <path
          d="M13.9204 19.68C13.655 19.68 13.4404 19.8946 13.4404 20.16C13.4404 20.4254 13.655 20.64 13.9204 20.64H15.9792C16.1812 20.3731 16.4011 20.0496 16.6204 19.68H13.9204Z"
          fill="#286AF6"
        />
      </g>
      <defs>
        <clipPath id="clip0_48697_84270">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </CustomSvg>
  );
};

export default ChatGe;
